import React from 'react';
import {tableIcons} from "../../config";
import {Add, AssistantPhoto, Edit} from "@material-ui/icons";
import MaterialTable from "material-table";
import * as moment from 'moment';

const Table = (
    {
        tableRef,
        title,
        loading,
        columns,
        loadTableData,
        selected,
        onSelect,
        onCreate,
        onEdit,
        onDestroy,
        addTooltip = 'Agregar registro',
        editTooltip = 'Editar registro',
        destroyTooltip = 'Desactivar registros',
        canCreate = true,
        canEdit = true,
        canDelete = true,
        canSelect = true,
        canSearch = true,
        canFilter = true,
        toolbar,
        customActions = [],
        shouldDefaultExport = true,
        ...props
    }) => {

    return <MaterialTable
        title={ title }
        tableRef={tableRef}
        icons={ tableIcons }
        isLoading={ loading }
        columns={
            columns
        }
        data={ loadTableData }
        actions={[
            canCreate ?
                {
                    icon: Add,
                    tooltip: addTooltip,
                    isFreeAction: true,
                    onClick: (event) => onCreate()
                } :
                null,
            canEdit ?
                {
                    icon: Edit,
                    tooltip: editTooltip,
                    onClick: (event, rowData) => onEdit(rowData[0].id),
                    disabled: (selected.length > 1)
                } :
                null,
            canDelete ?
                {
                    icon: AssistantPhoto,
                    tooltip: destroyTooltip,
                    onClick: (event, rowData) => onDestroy(),
                } :
                null,
            ...customActions
        ]}
        options={{
            selection: canSelect,
            search: canSearch,
            filtering: canFilter,
            exportButton: shouldDefaultExport,
            exportFileName: `${title}_prosys_${ moment().format('YYYY_MM_DD')}`,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [10, 25, 50],
            pageSize: 10,
        }}
        onSelectionChange={onSelect}
        localization={{
            pagination: {
                labelDisplayedRows: '{from}-{to} de {count}',
                nextTooltip: 'Siguiente',
                lastTooltip: 'Última',
                firstTooltip: 'Primera',
                previousTooltip: 'Anterior',
                labelRowsPerPage: 'Filas por página:',
                labelRowsSelect: 'filas'
            },
            toolbar: {
                nRowsSelected: '{0} fila(s) seleccionada(s)',
                searchTooltip: 'Buscar',
                searchPlaceholder: 'Buscar',
                exportTitle: 'Exportar',
                exportName: 'Exportar como CSV'
            },
            header: {
                actions: 'Acciones'
            },
            body: {
                emptyDataSourceMessage: 'No hay registros disponibles',
                filterRow: {
                    filterTooltip: 'Filtrar'
                }
            }
        }}
        {...props}
    />
};

export default Table;
